import { Model } from 'pinia-orm';
import Application from './Application';
import moment from 'moment';

export default class Experience extends Model {

    static get entity () {
        return 'experiences';
    }

    static fields () {
        return {
            id: this.uid(),
            company: this.string(''),
            tasks: this.string(''),
            job_description: this.string(''),
            job_title: this.string(''),
            application_id: this.attr(null),
            date_from: this.attr(null),
            date_to: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            application: this.belongsTo(Application, 'application_id'),
        }
    }

    get fromMoment () {
        return moment(this.date_from);
    }

    get toMoment () {
        return moment(this.date_to);
    }
}
